import { useAsync, useMountEffect } from "@react-hookz/web";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import { useEditionValue } from "~/lib/edition";
import type { hooksBurgerMenuTopicsQuery } from "~/queries/__generated__/hooksBurgerMenuTopicsQuery.graphql";

export const useBurgerMenuTopics = () => {
  const environment = useRelayEnvironment();
  const currentEdition = useEditionValue();

  const [{ result: data }, { execute }] = useAsync(() =>
    fetchQuery<hooksBurgerMenuTopicsQuery>(
      environment,
      graphql`
        query hooksBurgerMenuTopicsQuery($name: String!) {
          queue(filter: { name: $name }) {
            items(first: 10) {
              edges {
                ...topicsMenuItemQueueItemsEdge
              }
            }
          }
        }
      `,
      { name: `related_topic_homepage_${currentEdition}_` },
    ).toPromise(),
  );

  useMountEffect(() => {
    void execute();
  });

  return data?.queue?.items?.edges ?? [];
};
